import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getRelativeURLWithParams } from 'utils/url';
import { REQUEST_ID_HEADER } from 'constants/headers';
import { getRequestId } from 'utils/requestId';
import { Method } from 'constants/enums';
import { CART_DETAILS } from 'constants/endpoints.api';
import { CartResponse } from './types';

export const useGetCartDetailsQuery = ({
  storeId,
  locale
}): UseQueryResult<CartResponse> =>
  useQuery({
    queryKey: ['getCartDetails', storeId, locale],
    queryFn: async () => {
      const url = getRelativeURLWithParams(CART_DETAILS, {
        storeId,
        locale
      });
      const res = await fetch(url, {
        headers: { [REQUEST_ID_HEADER]: getRequestId() },
        method: Method.GET
      });
      if (res.ok) {
        const response = await res.json();
        return response;
      } else {
        throw new Error('server error');
      }
    },
    enabled: false
  });
